const INFO_ERROR = "INFO_ERROR"



module.exports = {
    INFO_ERROR,
}